module.exports = __webpack_public_path__ + "static/media/ic_emptyCheck.fa47d943.svg";